import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';

import { PollSchema, type PollBlockData } from './schema';
import View from './View';

interface EditProps {
  data: PollBlockData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: PollBlockData) => void;
}

const Edit: React.FC<EditProps> = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const schema = PollSchema();

  return (
    <div className="poll-edit">
      <View data={data} block={block} mode="edit" />
      <SidebarPortal selected={selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
